import CostumeCheckBox from "../../../../../../../../UiKit/CostumeCheckBox/CostumeCheckBox";
import ShapeCheckBox from "../../../../ShapeCheckBox/ShapeCheckBox";
import stl from "./CheckBox.module.css";
import { CDN_LINK } from "@globalConfig";

const CheckBox = ({
  label,
  value,
  onChange,
  checked,
  logo,
  alt,
  count,
  color,
  option,
  isColorFilter,
  carshape,
  carShapeImage,
  carType,
  disabled,
                      filter
}) => {
  return carshape ? (
    <>
      <ShapeCheckBox
        name={carType}
        count={count}
        image={carShapeImage}
        disabled={disabled}
        onChange={() => {
          onChange(
            filter,
            option,
            filter?.filterField === "condition_id" ? true : false
          );
        }}
        checked={checked}
        value={value}
      />
    </>
  ) : (
    <>
      <label className={stl.container} data-disable={disabled}>
        {isColorFilter && (
          <div
            className={stl.colorBox}
            style={{
              backgroundImage: !color
                ? "url(/assets/images/multiColor.png)"
                : undefined,
              backgroundColor: color,
              borderColor:
                color.indexOf("FFFFFF") > -1 ? "#cdd1d4" : "transparent",
            }}
          ></div>
        )}
        {logo && (
          <div className={stl.carLogo}>
            <img src={logo} alt={alt} />
          </div>
        )}
        <div className={stl.labelStyle}>
          {label} {count && <span className={stl.count}>({count})</span>}
        </div>

        <CostumeCheckBox
          disabled={disabled}
          className={stl.checkboxStyle}
          onChange={() => {

            onChange(
              filter,
              option,
              filter?.filterField === "condition_id"
            );
          }}
          checked={checked}
          src={CDN_LINK + "/assets/images/search-checkbox.svg"}
          value={value}
        />
      </label>
    </>
  );
};

export default CheckBox;
